import React from 'react'
import { Input as AntdInput } from 'antd'

import { TextareaProps } from './TextareaProps'

import { StyledInput } from './styles'

const { TextArea } = AntdInput

const TextAreaInput: React.FC<TextareaProps> = ({
  placeholder,
  value,
  onChange,
}) => (
  <StyledInput>
    <TextArea value={value} placeholder={placeholder} onChange={onChange} />
  </StyledInput>
)

export default TextAreaInput
